const types = {
login: '[Login del usuario]',
logout: '[Logout del usuario]',
isLoading: '[Loading]',
permissions: '[Load Permissions After Login]'
}

export default types